import { create } from 'zustand';

interface AtlasAccessStore {
  isAccessDenied: boolean;
  reason: 'atlas_access_denied' | 'atlas_user_missing' | 'atlas_user_baja';
  denyAccess: (reason?: AtlasAccessStore['reason']) => void;
  clearAccessDenied: () => void;
}

export const useAtlasAccessStore = create<AtlasAccessStore>((set) => ({
  isAccessDenied: false,
  reason: 'atlas_access_denied',
  denyAccess: (reason = 'atlas_access_denied') => set({ isAccessDenied: true, reason }),
  clearAccessDenied: () => set({ isAccessDenied: false, reason: 'atlas_access_denied' }),
}));
